import { render, staticRenderFns } from "./NavigaitionLinks.vue?vue&type=template&id=ffc4a9ca&"
import script from "./NavigaitionLinks.vue?vue&type=script&lang=ts&"
export * from "./NavigaitionLinks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports